import { useQuery } from "@tanstack/react-query";
import api from "../../api/apiClient";
import { OpeningHoursWithInheritance } from "../../types/modules/opening-hours.type";
import { getStoreId } from "../../utils/auth";

export const useProductOpeningHours = (
    storeId: number | undefined,
    productId: number | undefined,
    enabled: boolean = true,
) => {
    const resolvedStoreId = storeId ?? getStoreId();

    return useQuery({
        queryKey: [
            "product-opening-hours",
            resolvedStoreId,
            productId,
        ],
        queryFn: () =>
            api
                .get<OpeningHoursWithInheritance>(
                    `product-opening-hours/current/${productId}?storeId=${resolvedStoreId}`,
                )
                .then((res) => res.data),
        enabled:
            enabled &&
            !!resolvedStoreId &&
            !!productId,
    });
};